import { render } from "./FavServices.vue?vue&type=template&id=7eab1768&scoped=true"
import script from "./FavServices.vue?vue&type=script&lang=js"
export * from "./FavServices.vue?vue&type=script&lang=js"

import "./FavServices.vue?vue&type=style&index=0&id=7eab1768&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7eab1768"]])

export default __exports__